import React, {Component} from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import {Button} from 'reactstrap';
import {generateURL, isAuthenticated} from '../../helper/APIUtils'
import {API_BASE_URL} from '../../constants/index'


class HsmErrorAlert extends Component {

	constructor(props) {
		super(props);
	}

	renderNotWorking() {
		return (
			<div className="container">

				<div className="row">
					<div className="col-sm-12">
						Yardımcı uygulamaya ulaşılamadı. Uygulamayı kurduktan sonra masaüstündeki bu
						(<img style={{height: '30px'}} src={process.env.REACT_APP_CONTEXT_NAME + "/image/bhelper.png"}/>)
						ikona tıklayarak çalıştırınız ve imzalama işleminize devam ediniz.
					</div>
				</div>

				<div className="row">
					<div className="col-sm-2"/>

					<div className="col-sm-8" style={{paddingTop: '30px'}}>
						<a href={isAuthenticated() ? generateURL(`${API_BASE_URL}/signature/helper/browserHelper/download?os=win32_x86`) :
							"https://eczacikartfatura.com/images/BrowserHelper.msi"}>
							<Button style={{margin: "0 0 0.3em 0", lineHeight: "0.8em"}}>İndir</Button>
						</a>
					</div>

					<div className="col-sm-2"/>
				</div>
				{/*<div className="row">*/}
					{/*<div className="col-sm-8">*/}
						{/*Windows x64*/}
					{/*</div>*/}
					{/*<div className="col-sm-4">*/}
						{/*<a href={generateURL(`${API_BASE_URL}/signature/helper/browserHelper/download?os=win32_x64`)}>*/}
							{/*<Button style={{margin: "0 0 0.3em 0", lineHeight: "0.8em"}}>İndir</Button>*/}
						{/*</a>*/}
					{/*</div>*/}
				{/*</div>*/}
			</div>
		)
	}

	renderErrorContent() {
		let error = this.props.error;

		return <span>{error.response.data.error.errorMessage}</span>
	}

	render() {

		let error = this.props.error;

		return error && <SweetAlert
			// type={this.props.from && this.props.from === "SignatureInformation" ? "info":"warning"}
			type="info"
			confirmBtnText="Tamam"
			confirmBtnBsStyle="danger"
			// title={this.props.from && this.props.from === "SignatureInformation" ? "Bilgi" : "Hata"}
			title="Bilgi"
			onConfirm={this.props.onConfirm}>

			{!error.response && this.renderNotWorking()}
			{error.response && this.renderErrorContent()}

		</SweetAlert>
	}
}

export default HsmErrorAlert;
